/* @ngInject */
export default function ($scope, AuthService, StaffReportsEnquiriesService, DataTablesService, LayoutService, STATUSES, $state, ReportsService, StatusService, $timeout, PreferencesService) {
	AuthService.redirectIfUnauthorized('view-enquiries', 'splash.home');

	LayoutService.setTitle('Enquiries Report');

	const updateButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

	const newButton = LayoutService.getPageHeader()
	                               .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-plus"></i> New</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       null,
			             displayName: 'Reports',
		             },
		             {
			             route:       'staff.reports.enquiries.root',
			             displayName: 'Enquiries Report',
		             },
	             ]);

	$scope.loading = true;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	const financialYear = ReportsService.financialYear();

	$scope.cachedStart = $scope.start = financialYear.start;
	$scope.cachedEnd = $scope.end = financialYear.end;

	$scope.reports = {
		summariesRegions:     {
			status:    STATUSES.UNLOADED,
			data:      [],
			error:     null,
			dataTable: null,
			handle:    () => {
				if (StatusService.isUnloaded($scope.reports.summariesRegions.status)) {
					$scope.reports.summariesRegions.status = STATUSES.LOADING;

					StaffReportsEnquiriesService
						.getSummariesRegions(
							$scope.cachedStart.format(),
							$scope.cachedEnd.format(),
						)
						.then((data) => {
							$scope.reports.summariesRegions.dataTable = DataTablesService.configure({
								title:         'Regions Summary Report',
								totalsColumns: $scope.mapMonthHeaders(data.data.monthHeaders),
							});

							$scope.reports.summariesRegions.data  = data.data;
							$scope.reports.summariesRegions.error = null;

							$scope.reports.summariesRegions.status = STATUSES.LOADED;
						})
						.catch((error) => {
							$scope.reports.summariesRegions.data  = [];
							$scope.reports.summariesRegions.error = error;

							$scope.reports.summariesRegions.status = STATUSES.ERRORED;
						});
				}
			},
		},
		summariesReasons:     {
			status:    STATUSES.UNLOADED,
			data:      [],
			error:     null,
			dataTable: null,
			handle:    () => {
				if (StatusService.isUnloaded($scope.reports.summariesReasons.status)) {
					$scope.reports.summariesReasons.status = STATUSES.LOADING;

					StaffReportsEnquiriesService
						.getSummariesReasonsNotReferred(
							$scope.cachedStart.format(),
							$scope.cachedEnd.format(),
						)
						.then((data) => {
							$scope.reports.summariesReasons.dataTable = DataTablesService.configure({
								title:         'Reasons Not Referred Summary Report',
								totalsColumns: $scope.mapMonthHeaders(data.data.monthHeaders),
							});

							$scope.reports.summariesReasons.data  = data.data;
							$scope.reports.summariesReasons.error = null;

							$scope.reports.summariesReasons.status = STATUSES.LOADED;
						})
						.catch((error) => {
							$scope.reports.summariesReasons.data  = [];
							$scope.reports.summariesReasons.error = error;

							$scope.reports.summariesReasons.status = STATUSES.ERRORED;
						});
				}
			},
		},
		summariesAllFunders:  {
			status:    STATUSES.UNLOADED,
			data:      [],
			error:     null,
			dataTable: null,
			handle:    () => {
				if (StatusService.isUnloaded($scope.reports.summariesAllFunders.status)) {
					$scope.reports.summariesAllFunders.status = STATUSES.LOADING;

					StaffReportsEnquiriesService
						.getSummariesAllFunders(
							$scope.cachedStart.format(),
							$scope.cachedEnd.format(),
						)
						.then((data) => {
							$scope.reports.summariesAllFunders.dataTable = DataTablesService.configure({
								title:         'All Funders Summary Report',
								totalsColumns: $scope.mapMonthHeaders(data.data.monthHeaders),
							}, {
								ordering: false,
							});

							$scope.reports.summariesAllFunders.data  = data.data;
							$scope.reports.summariesAllFunders.error = null;

							$scope.reports.summariesAllFunders.status = STATUSES.LOADED;
						})
						.catch((error) => {
							$scope.reports.summariesAllFunders.data  = [];
							$scope.reports.summariesAllFunders.error = error;

							$scope.reports.summariesAllFunders.status = STATUSES.ERRORED;
						});
				}
			},
		},
		summariesNDIS:        {
			status:    STATUSES.UNLOADED,
			data:      [],
			error:     null,
			dataTable: null,
			handle:    () => {
				if (StatusService.isUnloaded($scope.reports.summariesNDIS.status)) {
					$scope.reports.summariesNDIS.status = STATUSES.LOADING;

					StaffReportsEnquiriesService
						.getSummariesNDIS(
							$scope.cachedStart.format(),
							$scope.cachedEnd.format(),
						)
						.then((data) => {
							$scope.reports.summariesNDIS.dataTable = DataTablesService.configure({
								title:         'NDIS Summary Report',
								totalsColumns: $scope.mapMonthHeaders(data.data.monthHeaders),
							}, {
								ordering: false,
							});

							$scope.reports.summariesNDIS.data  = data.data;
							$scope.reports.summariesNDIS.error = null;

							$scope.reports.summariesNDIS.status = STATUSES.LOADED;
						})
						.catch((error) => {
							$scope.reports.summariesNDIS.data  = [];
							$scope.reports.summariesNDIS.error = error;

							$scope.reports.summariesNDIS.status = STATUSES.ERRORED;
						});
				}
			},
		},
		summariesIcare:       {
			status:    STATUSES.UNLOADED,
			data:      [],
			error:     null,
			dataTable: null,
			handle:    () => {
				if (StatusService.isUnloaded($scope.reports.summariesIcare.status)) {
					$scope.reports.summariesIcare.status = STATUSES.LOADING;

					StaffReportsEnquiriesService
						.getSummariesIcare(
							$scope.cachedStart.format(),
							$scope.cachedEnd.format(),
						)
						.then((data) => {
							$scope.reports.summariesIcare.dataTable = DataTablesService.configure({
								title:         'Icare Summary Report',
								totalsColumns: $scope.mapMonthHeaders(data.data.monthHeaders),
							}, {
								ordering: false,
							});

							$scope.reports.summariesIcare.data  = data.data;
							$scope.reports.summariesIcare.error = null;

							$scope.reports.summariesIcare.status = STATUSES.LOADED;
						})
						.catch((error) => {
							$scope.reports.summariesIcare.data  = [];
							$scope.reports.summariesIcare.error = error;

							$scope.reports.summariesIcare.status = STATUSES.ERRORED;
						});
				}
			},
		},
		individualsEnquiries: {
			status:    STATUSES.UNLOADED,
			data:      [],
			error:     null,
			dataTable: DataTablesService.configure({
				title: 'Enquiries Report',
			}, {
				order: [
					[
						0,
						'desc',
					],
				],
			}),
			handle:    () => {
				if (StatusService.isUnloaded($scope.reports.individualsEnquiries.status)) {
					$scope.reports.individualsEnquiries.status = STATUSES.LOADING;

					StaffReportsEnquiriesService
						.getIndividualsEnquiries(
							$scope.cachedStart.format(),
							$scope.cachedEnd.format(),
						)
						.then((data) => {
							$scope.reports.individualsEnquiries.data  = data.data;
							$scope.reports.individualsEnquiries.error = null;

							$scope.reports.individualsEnquiries.status = STATUSES.LOADED;
						})
						.catch((error) => {
							$scope.reports.individualsEnquiries.data  = [];
							$scope.reports.individualsEnquiries.error = error;

							$scope.reports.individualsEnquiries.status = STATUSES.ERRORED;
						});
				}
			},
		},
	};

	$scope.unloadReports = () => {
		$scope.reportLoaded = {
			summariesRegions:     false,
			summariesReasons:     false,
			summariesAllFunders:  false,
			summariesNDIS:        false,
			summariesIcare:       false,
			individualsEnquiries: false,
		};
	};

	$scope.reportLoaded = {};


	$scope.apiURL = process.env.API_ENDPOINT;
	$scope.token  = AuthService.getToken();

	$scope.activeTabs = {
		summaries:   0,
		individuals: 0,
	};

	$scope.$watch('activeTabs.summaries', () => {
		$timeout(() => {
			$scope.handleTabs();
		});
	});

	$scope.$watch('activeTabs.individuals', () => {
		$timeout(() => {
			$scope.handleTabs();
		});
	});

	$scope.handleTabs = () => {
		switch ($scope.activeTabs.summaries) {
			case 0: {
				$scope.reportLoaded.summariesRegions = true;

				break;
			}
			case 1: {
				$scope.reportLoaded.summariesReasons = true;

				break;
			}
			case 2: {
				$scope.reportLoaded.summariesAllFunders = true;

				break;
			}
			case 3: {
				$scope.reportLoaded.summariesNDIS = true;

				break;
			}
			case 4: {
				$scope.reportLoaded.summariesIcare = true;

				break;
			}

		}

		switch ($scope.activeTabs.individuals) {
			case 0: {
				$scope.reportLoaded.individualsEnquiries = true;

				break;
			}
		}

	};

	$scope.refresh = () => {
		$scope.cachedStart = $scope.start;
		$scope.cachedEnd   = $scope.end;

		$scope.dateRange = {
			start: $scope.cachedStart,
			end:   $scope.cachedEnd,
		};

		$scope.unloadReports();

		$timeout(() => {
			$scope.handleTabs();
		});

	};

	LayoutService.getPageHeader()
	             .onClicked(updateButton, $scope.refresh);

	LayoutService.getPageHeader()
	             .onClicked(newButton, () => {
		             $state.go('staff.reports.enquiries.new');
	             });

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/enquiries/root/controller.js